import { render, staticRenderFns } from "./JournalArticles.vue?vue&type=template&id=297dfb6d&scoped=true&"
import script from "./JournalArticles.vue?vue&type=script&lang=js&"
export * from "./JournalArticles.vue?vue&type=script&lang=js&"
import style0 from "./JournalArticles.vue?vue&type=style&index=0&id=297dfb6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297dfb6d",
  null
  
)

export default component.exports